// 사용자 동의서 카테고리 API
import HTTP from 'apiDefault'

// 동의서 카테고리 생성
const add = (accountID, data, order) => {
  return HTTP.post(`/category/${accountID}/create`, {
      name: data,
      categoryOrder: order,
      category_order: order,
    }
    , { headers: { Authorization: window._VUE_STATE.header } })
}

// 동의서 카테고리 삭제
const remove = (accountID, categoryID) => {
  return HTTP.delete(`/category/${accountID}/delete/${categoryID}`
    , { headers: { Authorization: window._VUE_STATE.header } })
}

// 동의서 카테고리 수정
const update = (accountID, categoryID, name, order) => {
  return HTTP.post(`/category/${accountID}/update`, {
      id: categoryID,
      name: name,
      categoryOrder: order,
    }
    , { headers: { Authorization: window._VUE_STATE.header } })
}

// 동의서 카테고리 목록 조회
// 동의서 템플릿 카테고리 목록 조회
const getTemplateList = (accountID) => {
  return HTTP.get(`/category/${accountID}/list?design_mode=false`
    , { headers: { Authorization: window._VUE_STATE.header } })
}

// 동의서 카테고리 목록 조회
// 디자인 목록(SuperAdmin이 만든 동의서 템플릿 카테고리) 조회
const getDesignList = (accountID) => {
  return HTTP.get(`/category/${accountID}/list?design_mode=true`
    , { headers: { Authorization: window._VUE_STATE.header } })
}

export {
  getDesignList,
  getTemplateList,
  add,
  remove,
  update,
}



// WEBPACK FOOTER //
// ./src/api/category.js